<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>Número</th>
          <th>Titulo</th>
          <th>Tipo</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ocorrencia in ocorrenciasFormat" :key="ocorrencia.id">
          <td data-label="Número">
            <span>{{ ocorrencia.id }}</span>
          </td>
          <td data-label="Titulo">
            <span>{{ ocorrencia.titulo }}</span>
          </td>
          <td data-label="Tipo">
            <span>{{ formatarTipo(ocorrencia.tipo) }}</span>
          </td>
          <td data-label="Status">
            <span>{{formatarStatus (ocorrencia.status) }}</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <!-- Visualizar -->
              <div class="icone-tabela">
                <router-link
                  :to="{
                    name: 'OcorrenciasShow',
                    params: { id: ocorrencia.id },
                  }"
                >
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar"/>
                </router-link>
              </div>
              <!-- Editar -->
              <div
                v-if="usuario_logado && ocorrencia.status === 'aberto' && usuario_logado.id === ocorrencia.usuario_id"
                class="icone-tabela">
                <router-link :to="{ name: 'OcorrenciasEdit', params: { id: ocorrencia.id } }">
                  <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                </router-link>
              </div>
              <!-- Excluir -->
              <button
                v-if="usuario_logado && ocorrencia.status === 'aberto' && usuario_logado.id === ocorrencia.usuario_id"
                class="icone-tabela"
                @click="opcoesExcluir(ocorrencia.id)">
                <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
              </button>
            </div>
          </td>
        </tr> 
        <tr v-if="!ocorrencias || ocorrencias.length === 0" class="sem-resultados">
          <td :colspan="5">
            <b>Nenhum Resultado Encontrado</b>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
  import {parseISO, format} from "date-fns"

  import MsgErroFormularios from "../MsgErroFormularios";
  import OcorrenciaApi from "../../services/OcorrenciaApi"
  import Auth from '../../services/Auth';

  export default {
    name: "TabelaResultadosOcorrencias",
    props: {
      ocorrencias: Array,
      ocorrencia: Object,
      usuario_logado: Object
    },
    created() {
      this.OcorrenciaApi = new OcorrenciaApi();
      this.auth = new Auth();
    },
    computed: {
      ocorrenciasFormat() {
        return this.ocorrencias?.map((v) => ({ ...v })) || [];
      }
    },
    components: {
      MsgErroFormularios,
    },
    data() {
      return {
        erro: false,
        msgErros: {
          ocorrencia: '',
          default: '',
        },
      }
    },
    methods: {
      formatarData: function(value) {
        if(value == null) {
          return;
        }
        return format(parseISO(value), "dd/MM/yyyy");
      },
      formatarDataParaComparacao(value) {
        let newValue = new Date(value);
        let timeToCompare = newValue.getTime();
        return timeToCompare;
      },
      formatarStatus(valor) {
          if (valor === 'aberto') {
              return 'Aberto';
          } else if (valor === 'em_andamento') {
              return 'Em Andamento';
          } else if (valor === 'finalizado') {
              return 'Finalizado';
          }
        },
        formatarTipo(valor) {
          if (valor === 'melhoria') {
              return 'Sugestão';
          } else if (valor === 'erro') {
              return 'Reporte de Erro';
          } else if (valor === 'duvida') {
              return 'Dúvida';
          } else if (valor === 'elogio') {
            return 'Elogio';            
          } else if (valor === 'reclamacao') {
            return 'Reclamação';
          }

          return valor; 
      },
    },
  };
</script>

<style lang="scss" scoped>
  .linha-selecionada {
    background-color: yellow;
  }

  @media screen and (min-width: "1066px") {
    .resultados {
      table {
        tbody {
          tr {
            td {
              padding: 1rem .7rem;
              vertical-align: middle;
              font-size: .9rem;
              text-align: center;
            }

            td:nth-child(1) {
              min-width: 9rem;
              padding: .9rem;
              text-align: left;          
            }

            td:nth-child(2) {
              text-align: left;
            }

            td:nth-child(3) {
              text-align: left;
            }

            td:nth-child(4) {
              text-align: left;
            }

            td:nth-child(5) {
              text-align: left;
              max-width: 50rem;
            }
          }

          .coluna-acoes-tabela {
            justify-content: center;
            
            .icone-tabela {
              margin: 0 .05rem 0 .05rem;
            }
          }
        }
      }

      td {
        img {
          height: 1.5rem;
          margin: 0rem 0.5rem 0rem 0.5rem;
        }
      }

      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: "570px") and (max-width: "1065px") {
    .resultados {
      .coluna-acoes-tabela {
        justify-content: flex-start;
        display: inline;
      }

      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: "60px") and (max-width: "569px") {
    .resultados {
      .coluna-acoes-tabela {
        justify-content: flex-start;
        display: inline;
      }

      .modal-edit {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: table;
        transition: opacity 0.3s ease;

        .modal-mask {
          border-radius: 1rem;
          position: relative;
          z-index: 1000;
          top: 20vh;
          width: calc(40vw - 10rem);
          height: auto;
          background-color: #f2f2f2;
          transition: opacity 0.3s ease;
          margin: 0 auto;
        }

        .modal-container {
          height: 100%;
          padding: .7rem;
          position: relative;
          overflow-y: auto;
          overflow-x: auto;
          font-family: "Montserrat-Medium";
          align-content: center;

          .modal-header {
            height: fit-content;
            width: fit-content;
            margin: .5rem auto .3rem auto;

            h2 {
              font-size: 1.3rem;
              font-weight: bold;
            }
          }

          .modal-body {
            border: 1px solid gray;
            border-radius: 1rem;
            text-align: -webkit-center;

            p {
              font-size: 1rem;
              font-weight: bold;
              margin-top: .3rem;
              margin-bottom: .5rem;
              margin-left: 1rem;
              color: #005516;
            }

            .dados {
              font-weight: bold;
              font-size: 1rem;
              text-align-last: left;
              margin: 0 1rem .5rem 1rem;

              span {
                font-weight: normal;
                font-size: .9rem;
                margin-left: .3rem;
              }
            }
          }

          .modal-footer {
            margin: .7rem auto 0rem auto;
            place-content: space-evenly;
            font-size: 1rem;

            .btn-confirmar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #005516;
              color: #f2f2f2;
            }

            .btn-confirmar-edicao:hover {
              background-color: #005517c2;
            }

            .btn-cancelar-edicao {
              border: none;
              border-radius: .5rem;
              width: 30%;
              height: 2.2rem;
              background-color: #bd0000;
              color: #f2f2f2;
            }

            .btn-cancelar-edicao:hover {
              background-color: #bd0000c4;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1065px) {
    .status-select {
      display: block; /* Garante que o v-select ocupe a largura total disponível */
      width: auto;
      max-width: 200px;
    }
  }

  .status-select::v-deep .vs__dropdown-toggle {
    min-height: 28px !important;
    height: 28px !important;
  }

  .status-select::v-deep .vs__selected {
    font-size: 0.8rem !important;
    line-height: 1.2 !important;
  }

  .status-select::v-deep .vs__search {
    font-size: 0.8rem !important;
  }

  .status-select::v-deep .vs__dropdown-menu {
    font-size: 0.8rem !important;
  }
</style>